import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
	button: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		transition: theme.transitions.create("all", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		}),
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
			opacity: 0.9
		}
	},
	whiteText: {
		color: colors.gray[0]
	},
	whiteInput: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		borderWidth: 0
	},
	whiteLabel: {
		background: colors.gray[0],
		padding: "0 6px",
		borderRadius: "9px"
	},
	whiteTextField: {
		"& legend": {
			height: 8
		}
	},
	errorText: {
		color: colors.red[400]
	}
}))

export default useStyles
